// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Minicart__couponItem__root","couponName":"cmp-Minicart__couponItem__couponName"};